@include host-component-properties;

:host {
  --paf-no-results-font-size-large: 20;
  --paf-no-results-line-height-large: 30;
  --paf-no-results-font-size-small: 17;
  --paf-no-results-line-height-small: 26;
  --paf-no-results-items-margin: 8;
}

.notification {
  font-size: px-to-rem(var(--paf-no-results-font-size-small));
  line-height: px-to-rem(var(--paf-no-results-line-height-small));
  text-align: center;

  @include mq($from: medium) {
    font-size: px-to-rem(var(--paf-no-results-font-size-large));
    line-height: px-to-rem(var(--paf-no-results-line-height-large));
  }

  .title {
    font-weight: var(--paf-global-font-weight-bold);
    font-size: inherit;
    margin-inline: 0;
    margin-block: 0 px-to-rem(var(--paf-no-results-items-margin));
  }

  .description {
    margin: 0;
  }
}
